module.exports = "//public.zight.com/packs/media/images/google_logo-d3a8a125e005f605586c4d29958fb3d8.svg";